import { formatNumberWithCustomSeparator } from '@elfsight/widget-utils';
import type { PriceProps } from '../types';

export function getPriceFormatter({
  locale,
  currency,
  thousandsSeparator,
  decimalSeparator,
  decimalPlaces
}: Pick<
  PriceProps,
  'currency' | 'decimalPlaces' | 'thousandsSeparator' | 'decimalSeparator'
> & {
  locale: string;
}) {
  const numberFormatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 10
  });

  const withoutCustomSeparator =
    thousandsSeparator === undefined && decimalSeparator === undefined;

  if (withoutCustomSeparator) {
    return (value: number) => numberFormatter.format(value);
  }

  return (value: number) => {
    const parts = numberFormatter.formatToParts(value);
    const currencyPart = parts.find((p) => p.type === 'currency');
    const currencySymbol = currencyPart?.value ?? '';
    const isCurrencyPrefix = parts[0]?.type === 'currency';

    const formattedNumber = formatNumberWithCustomSeparator(
      value.toLocaleString(undefined, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces ?? 10,
        useGrouping: false
      }),
      thousandsSeparator,
      decimalSeparator
    );

    return isCurrencyPrefix
      ? `${currencySymbol}${formattedNumber}`
      : `${formattedNumber}${currencySymbol}`;
  };
}
